'use strict';

angular.module('front', []);
